var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElitePlan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#383838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6797 17.5989L25.0859 12.3489C25.0245 12.2788 24.9488 12.2225 24.864 12.1839C24.7791 12.1453 24.687 12.1252 24.5937 12.125H15.4062C15.313 12.1252 15.2209 12.1453 15.136 12.1839C15.0511 12.2225 14.9755 12.2788 14.914 12.3489L10.3203 17.5989C10.2131 17.7213 10.1552 17.8791 10.1578 18.0417C10.1604 18.2044 10.2233 18.3602 10.3342 18.4791L19.5217 28.3229C19.5831 28.3887 19.6574 28.4412 19.74 28.4771C19.8225 28.513 19.9116 28.5315 20.0016 28.5315C20.0916 28.5315 20.1807 28.513 20.2633 28.4771C20.3458 28.4412 20.4201 28.3887 20.4815 28.3229L29.669 18.4791C29.7795 18.3598 29.8418 18.2037 29.8438 18.0411C29.8458 17.8785 29.7873 17.7209 29.6797 17.5989ZM27.7413 17.375H24.2656L21.3125 13.4375H24.296L27.7413 17.375ZM15.6179 18.6875L18.0895 24.8669L12.3227 18.6875H15.6179ZM22.9679 18.6875L20 26.108L17.0321 18.6875H22.9679ZM17.375 17.375L20 13.8747L22.625 17.375H17.375ZM24.3821 18.6875H27.6773L21.9105 24.8669L24.3821 18.6875ZM15.704 13.4375H18.6875L15.7344 17.375H12.2587L15.704 13.4375Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElitePlan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/elite++-plan.0f703595c7f9044367c9d780304ec573.svg";